import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as n, isNone as t } from "../../core/maybe.js";
import { isPoint as e, isPolyline as r, isPolygon as u, isMultipoint as i, isExtent as o } from "./jsonUtils.js";

function l(n) {
  return n && "upperLeft" === n.originPosition;
}

var a = function a(n, t, e) {
  return [t, e];
},
    m = function m(n, t, e) {
  return [t, e, n[2]];
},
    c = function c(n, t, e) {
  return [t, e, n[2], n[3]];
};

function s(t) {
  if (!t) return null;
  return {
    originPosition: "upper-left" === t.originPosition ? "upperLeft" : "lower-left" === t.originPosition ? "lowerLeft" : t.originPosition,
    scale: t.tolerance ? [t.tolerance, t.tolerance] : [1, 1],
    translate: n(t.extent) ? [t.extent.xmin, t.extent.ymax] : [0, 0]
  };
}

function f(t, e) {
  if (t === e || null == t && null == e) return !0;
  if (null == t || null == e) return !1;
  var r, u, i, o, a, m;
  return l(t) ? (r = t.translate[0], u = t.translate[1], i = t.scale[0]) : (r = n(t.extent) ? t.extent.xmin : 0, u = n(t.extent) ? t.extent.ymax : 0, i = t.tolerance), l(e) ? (o = e.translate[0], a = e.translate[1], m = e.scale[0]) : (o = n(e.extent) ? e.extent.xmin : 0, a = n(e.extent) ? e.extent.ymax : 0, m = e.tolerance), r === o && u === a && i === m;
}

function x(_ref, e) {
  var n = _ref.scale,
      t = _ref.translate;
  return Math.round((e - t[0]) / n[0]);
}

function h(_ref2, e) {
  var n = _ref2.scale,
      t = _ref2.translate;
  return Math.round((t[1] - e) / n[1]);
}

function I(n, t, e) {
  var r = [];
  var u, i, o, l;

  for (var _a = 0; _a < e.length; _a++) {
    var _m = e[_a];
    _a > 0 ? (o = x(n, _m[0]), l = h(n, _m[1]), o === u && l === i || (r.push(t(_m, o - u, l - i)), u = o, i = l)) : (u = x(n, _m[0]), i = h(n, _m[1]), r.push(t(_m, u, i)));
  }

  return r.length > 0 ? r : null;
}

function g(n, t, e) {
  return t[0] = x(n, e[0]), t[3] = h(n, e[1]), t[2] = x(n, e[2]), t[1] = h(n, e[3]), t;
}

function p(n, t, e, r) {
  return I(n, e ? r ? c : m : r ? m : a, t);
}

function N(n, t, e, r) {
  var u = [],
      i = e ? r ? c : m : r ? m : a;

  for (var _o = 0; _o < t.length; _o++) {
    var _e = I(n, i, t[_o]);

    _e && _e.length >= 3 && u.push(_e);
  }

  return u.length ? u : null;
}

function y(n, t, e, r) {
  var u = [],
      i = e ? r ? c : m : r ? m : a;

  for (var _o2 = 0; _o2 < t.length; _o2++) {
    var _e2 = I(n, i, t[_o2]);

    _e2 && _e2.length >= 2 && u.push(_e2);
  }

  return u.length ? u : null;
}

function z(_ref3, e) {
  var n = _ref3.scale,
      t = _ref3.translate;
  return e * n[0] + t[0];
}

function T(_ref4, e) {
  var n = _ref4.scale,
      t = _ref4.translate;
  return t[1] - e * n[1];
}

function M(n, t, e) {
  var r = new Array(e.length);
  if (!e.length) return r;

  var _n$scale = _slicedToArray(n.scale, 2),
      u = _n$scale[0],
      i = _n$scale[1];

  var o = z(n, e[0][0]),
      l = T(n, e[0][1]);
  r[0] = t(e[0], o, l);

  for (var _a2 = 1; _a2 < e.length; _a2++) {
    var _n = e[_a2];
    o += _n[0] * u, l -= _n[1] * i, r[_a2] = t(_n, o, l);
  }

  return r;
}

function E(n, t, e) {
  var r = new Array(e.length);

  for (var _u = 0; _u < e.length; _u++) {
    r[_u] = M(n, t, e[_u]);
  }

  return r;
}

function P(n, t, e) {
  return e ? (t[0] = z(n, e[0]), t[1] = T(n, e[3]), t[2] = z(n, e[2]), t[3] = T(n, e[1]), t) : [z(n, t[0]), T(n, t[3]), z(n, t[2]), T(n, t[1])];
}

function b(n, t, e, r) {
  return M(n, e ? r ? c : m : r ? m : a, t);
}

function F(n, t, e, r) {
  return E(n, e ? r ? c : m : r ? m : a, t);
}

function V(n, t, e, r) {
  return E(n, e ? r ? c : m : r ? m : a, t);
}

function Y(n, t, e) {
  var _e$ = _slicedToArray(e[0], 2),
      r = _e$[0],
      u = _e$[1],
      i = Math.min(r, t[0]),
      o = Math.min(u, t[1]),
      l = Math.max(r, t[2]),
      a = Math.max(u, t[3]);

  for (var _m2 = 1; _m2 < e.length; _m2++) {
    var _e$_m = _slicedToArray(e[_m2], 2),
        _n2 = _e$_m[0],
        _t = _e$_m[1];

    r += _n2, u += _t, _n2 < 0 && (i = Math.min(i, r)), _n2 > 0 && (l = Math.max(l, r)), _t < 0 ? o = Math.min(o, u) : _t > 0 && (a = Math.max(a, u));
  }

  return n[0] = i, n[1] = o, n[2] = l, n[3] = a, n;
}

function _(n, t) {
  if (!t.length) return null;
  n[0] = n[1] = Number.POSITIVE_INFINITY, n[2] = n[3] = Number.NEGATIVE_INFINITY;

  for (var _e3 = 0; _e3 < t.length; _e3++) {
    Y(n, n, t[_e3]);
  }

  return n;
}

function A(n) {
  var t = [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY];
  return Y(t, t, n);
}

function w(n) {
  return _([0, 0, 0, 0], n);
}

function j(n) {
  return _([0, 0, 0, 0], n);
}

function G(n, t, e, r, u) {
  return t.xmin = x(n, e.xmin), t.ymin = h(n, e.ymin), t.xmax = x(n, e.xmax), t.ymax = h(n, e.ymax), t !== e && (r && (t.zmin = e.zmin, t.zmax = e.zmax), u && (t.mmin = e.mmin, t.mmax = e.mmax)), t;
}

function L(n, t, e, r, u) {
  return t.points = p(n, e.points, r, u), t;
}

function O(n, t, e, r, u) {
  return t.x = x(n, e.x), t.y = h(n, e.y), t !== e && (r && (t.z = e.z), u && (t.m = e.m)), t;
}

function S(n, t, e, r, u) {
  var i = N(n, e.rings, r, u);
  return i ? (t.rings = i, t) : null;
}

function d(n, t, e, r, u) {
  var i = y(n, e.paths, r, u);
  return i ? (t.paths = i, t) : null;
}

function U(n, t) {
  return n && t ? e(t) ? O(n, {}, t, !1, !1) : r(t) ? d(n, {}, t, !1, !1) : u(t) ? S(n, {}, t, !1, !1) : i(t) ? L(n, {}, t, !1, !1) : o(t) ? G(n, {}, t, !1, !1) : null : null;
}

function k(n, t, e, r, u) {
  return t.xmin = z(n, e.xmin), t.ymin = T(n, e.ymin), t.xmax = z(n, e.xmax), t.ymax = T(n, e.ymax), t !== e && (r && (t.zmin = e.zmin, t.zmax = e.zmax), u && (t.mmin = e.mmin, t.mmax = e.mmax)), t;
}

function q(t, e, r, u, i) {
  return n(r) && (e.points = b(t, r.points, u, i)), e;
}

function v(n, e, r, u, i) {
  return t(r) || (e.x = z(n, r.x), e.y = T(n, r.y), e !== r && (u && (e.z = r.z), i && (e.m = r.m))), e;
}

function B(t, e, r, u, i) {
  return n(r) && (e.rings = V(t, r.rings, u, i)), e;
}

function C(t, e, r, u, i) {
  return n(r) && (e.paths = F(t, r.paths, u, i)), e;
}

export { f as equals, Y as getQuantizedBoundsCoordsArray, _ as getQuantizedBoundsCoordsArrayArray, w as getQuantizedBoundsPaths, A as getQuantizedBoundsPoints, j as getQuantizedBoundsRings, g as quantizeBounds, G as quantizeExtent, U as quantizeGeometry, L as quantizeMultipoint, y as quantizePaths, O as quantizePoint, p as quantizePoints, S as quantizePolygon, d as quantizePolyline, N as quantizeRings, x as quantizeX, h as quantizeY, s as toQuantizationTransform, P as unquantizeBounds, M as unquantizeCoordsArray, E as unquantizeCoordsArrayArray, k as unquantizeExtent, q as unquantizeMultipoint, F as unquantizePaths, v as unquantizePoint, b as unquantizePoints, B as unquantizePolygon, C as unquantizePolyline, V as unquantizeRings, z as unquantizeX, T as unquantizeY };